import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useParams, useHistory } from "react-router-dom";
import FiveSlotMachineDetailCard from "./components/FiveSlotMachineDetailCard";
import { DUMMY_LOTTERIES } from "./FiveSlotLottery";
import NavBar from "../../../Components/NavBar";
import { connectWallet as triggerConnectWallet } from "../../../../static/walletUtils";
import { Path } from "../../../../static/Constants";
import { colors, borderRadiusPx, customShadows } from "../../../../theme";
import { CommonBreadcrumbs, CommonButton } from "../../../Components/ui";
import { FIVE_SLOT_DETAILS_THEME } from "./components/fiveSlotConfig";

const FiveSlotLotteryDetails = () => {
  const { id } = useParams();
  const history = useHistory();

  const [account, setAccount] = useState("");
  const [isCheckingWallet, setIsCheckingWallet] = useState(true);

  // User-specific values
  const [balance, setBalance] = useState("1250.00");
  const [win, setWin] = useState("0.00");

  // Find the lottery using the ID from the URL or contract
  const [lotteryData] = useState(() => {
    const found = DUMMY_LOTTERIES.find((lottery) => lottery.lotteryId.toString() === id);
    return (
      found || {
        lotteryId: id || 201,
        name: `5-SlotBET #${id || 201}`,
        creator: "AutoBET Official",
        slotCategory: "fiat",
        jackpots: {
          mini: { amount: "2840.50", seedValue: "2000.00", contributionPerSpin: "0.030" },
          major: { amount: "16450.00", seedValue: "10000.00", contributionPerSpin: "0.012" },
          mega: { amount: "128900.00", seedValue: "50000.00", contributionPerSpin: "0.005" },
        },
      }
    );
  });

  // Check whether a wallet is already connected
  useEffect(() => {
    const checkWalletConnection = async () => {
      if (!window.ethereum) {
        setIsCheckingWallet(false);
        return;
      }

      try {
        const accounts = await window.ethereum.request({
          method: "eth_accounts",
        });

        if (accounts && accounts.length > 0) {
          setAccount(accounts[0]);
        }
      } catch (error) {
        console.error("Failed to check wallet connection:", error);
      } finally {
        setIsCheckingWallet(false);
      }
    };

    checkWalletConnection();
  }, []);

  // Listen for wallet changes
  useEffect(() => {
    if (!window.ethereum) return;

    const handleAccountsChanged = (accounts) => {
      setAccount(accounts?.[0] || "");
    };

    window.ethereum.on("accountsChanged", handleAccountsChanged);

    return () => {
      window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
    };
  }, []);

  const handleConnectWallet = async () => {
    const res = await triggerConnectWallet();
    if (res.account) {
      setAccount(res.account);
    }
  };

  if (isCheckingWallet) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "relative",
        overflowX: "hidden",
        minHeight: "100vh",
        bgcolor: FIVE_SLOT_DETAILS_THEME.pageBg || colors.dashboard.canvas,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar />
      <Container
        maxWidth={FIVE_SLOT_DETAILS_THEME.containerMaxWidth || "lg"}
        className="slot-page-container"
        sx={{
          pt: { xs: "90px", sm: "100px", md: "108px" },
          pb: { xs: 4, md: 8 },
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: FIVE_SLOT_DETAILS_THEME.cardMaxWidth || 590,
            mb: 2.5,
          }}
        >
          {/* Breadcrumbs Navigation */}
          <CommonBreadcrumbs
            items={[
              { label: "Home", path: Path.root },
              { label: "5-SlotBET", path: Path.FiveSlotlottery || "/five-slotlottery" },
              { label: lotteryData.name || `5-SlotBET #${id || 201}` },
            ]}
          />

          {/* Action Row */}
          <Box
            sx={{
              mt: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <CommonButton
              variant="refresh"
              size="small"
              startIcon={<ArrowBackIcon />}
              onClick={() => history.push(Path.FiveSlotlottery || "/five-slotlottery")}
            >
              Back to Arena
            </CommonButton>

            {!account && (
              <CommonButton
                variant="primary"
                size="small"
                startIcon={<AccountBalanceWalletIcon />}
                onClick={handleConnectWallet}
              >
                Connect Wallet
              </CommonButton>
            )}
          </Box>
        </Box>

        {/* The 5-Slot Pokies Mobile-first Interface */}
        <Box sx={{ width: "100%", maxWidth: FIVE_SLOT_DETAILS_THEME.cardMaxWidth || 590 }}>
          <FiveSlotMachineDetailCard
            lotteryData={lotteryData}
            account={account}
            balance={balance}
            win={win}
            setBalance={setBalance}
            setWin={setWin}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default FiveSlotLotteryDetails;
